import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AppStepUpdatePage } from './app-step-update';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    AppStepUpdatePage,
  ],
  imports: [
    IonicPageModule.forChild(AppStepUpdatePage),
    PipesModule,
    DirectivesModule,

  ],
})
export class AppStepUpdatePageModule {}



// WEBPACK FOOTER //
// ./src/pages/app-step-update/app-step-update.module.ts